// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"BannerContainer_BannerContainer__2JGVu","BannerDesk":"BannerContainer_BannerDesk__3XOdy","BannerMob":"BannerContainer_BannerMob__26pfz"};